(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["catalog-browser"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sv-catalog-browser')) {
    customElements.define('sv-catalog-browser', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        const form = this.querySelector('form');
        const panel = this.querySelector('[data-catalog-panel]');
        const mobile = window.matchMedia('(max-width: 900px)');
        const resize = () => { panel.open = !mobile.matches; };
        resize();
        mobile.addEventListener('change', resize);
        this.cleanup = () => mobile.removeEventListener('change', resize);
        const min = form.querySelector('[data-price-min]');
        const max = form.querySelector('[data-price-max]');
        const validatePrice = () => {
          if (!min || !max) return;
          max.setCustomValidity(min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value) ? this.dataset.priceError : '');
        };
        [min, max].forEach(input => input?.addEventListener('input', validatePrice));
        form.addEventListener('invalid', () => {
          panel.open = true;
          if (max?.validationMessage) max.closest('details').open = true;
        }, true);
        const sort = this.querySelector('[data-catalog-sort]');
        this.querySelector('[data-stock-option]').hidden = false;
        const currentUrl = new URL(window.location.href);
        if (currentUrl.searchParams.get('sv_sort') === 'in-stock') sort.value = 'sv-in-stock';
        form.addEventListener('formdata', event => {
          if (sort.value === 'sv-in-stock') {
            event.formData.set('sort_by', this.dataset.stockBaseSort);
            event.formData.set('sv_sort', 'in-stock');
          }
          for (const [key, value] of [...event.formData.entries()]) {
            if (value === '') event.formData.delete(key);
          }
        });
        this.querySelector('[data-catalog-sort]').addEventListener('change', () => { validatePrice(); form.requestSubmit(); });
        this.classList.add('is-enhanced');
        if (sort.value === 'sv-in-stock') {
          this.querySelectorAll('.sv-browse__active a,.sv-browse__filter-head>a').forEach(link => {
            const url = new URL(link.href);
            url.searchParams.set('sv_sort', 'in-stock');
            url.searchParams.delete('page');
            url.searchParams.delete('sv_page');
            link.href = url.href;
          });
          this.loadStockResults(currentUrl);
        }
        this.onStockPop = () => {
          if (this.stockCards) this.renderStockPage(new URL(window.location.href), false);
        };
        window.addEventListener('popstate', this.onStockPop);
      }
      async loadStockResults(currentUrl) {
        this.stockAbort?.abort();
        const controller = new AbortController();
        this.stockAbort = controller;
        const status = this.querySelector('[data-stock-status]');
        const results = this.querySelector('[data-catalog-results]');
        status.hidden = false;
        status.textContent = this.dataset.stockLoading;
        results.hidden = true;
        results.setAttribute('aria-busy', 'true');
        const timeout = setTimeout(() => controller.abort(), 30000);
        try {
          let url = new URL(currentUrl);
          url.searchParams.delete('page');
          url.searchParams.delete('sv_page');
          url.searchParams.delete('sv_sort');
          url.searchParams.set('section_id', 'sv-stock-results');
          const cards = new Map();
          const visited = new Set();
          let expected = null;
          while (url) {
            if (url.origin !== window.location.origin || visited.has(url.href) || visited.size >= 40) throw new Error('Invalid stock pagination');
            visited.add(url.href);
            const response = await fetch(url.href, {signal:controller.signal, credentials:'same-origin'});
            if (!response.ok) throw new Error('Stock request failed');
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const data = doc.querySelector('[data-stock-results]');
            if (!data) throw new Error('Stock section missing');
            const total = Number(data.dataset.total);
            if (!Number.isSafeInteger(total) || total < 0 || total > 10000) throw new Error('Invalid stock total');
            if (expected !== null && expected !== total) throw new Error('Stock results changed');
            expected = total;
            data.querySelectorAll('[data-stock-product]').forEach(card => cards.set(card.dataset.stockProduct, card));
            url = data.dataset.next ? new URL(data.dataset.next, url) : null;
            if (url) url.searchParams.set('section_id', 'sv-stock-results');
          }
          if (cards.size !== expected) throw new Error('Incomplete stock results');
          this.stockCards = [...cards.values()].sort((a,b) => Number(b.dataset.stockRank)-Number(a.dataset.stockRank) || a.dataset.stockTitle.localeCompare(b.dataset.stockTitle, document.documentElement.lang || 'en', {numeric:true,sensitivity:'base'}) || a.dataset.stockProduct.localeCompare(b.dataset.stockProduct));
          this.renderStockPage(currentUrl, false);
          status.textContent = this.dataset.stockReady;
        } catch (error) {
          if (!this.isConnected) return;
          status.textContent = this.dataset.stockError;
          results.hidden = false;
        } finally {
          clearTimeout(timeout);
          results.removeAttribute('aria-busy');
        }
      }
      renderStockPage(url, focus) {
        const results = this.querySelector('[data-catalog-results]');
        const pages = Math.max(1, Math.ceil(this.stockCards.length / 24));
        const requested = Number(url.searchParams.get('sv_page')) || 1;
        const page = Math.min(pages, Math.max(1, Math.floor(requested)));
        if (requested !== page) {
          url.searchParams.set('sv_page', page);
          history.replaceState(null, '', url);
        }
        if (this.stockCards.length) {
          const grid = document.createElement('div');
          grid.className = 'sv-product-grid sv-browse__grid';
          this.stockCards.slice((page-1)*24, page*24).forEach(card => grid.append(card.cloneNode(true)));
          results.replaceChildren(grid);
          if (pages > 1) {
            const nav = document.createElement('nav');
            nav.className = 'sv-pagination';
            nav.setAttribute('aria-label', this.dataset.stockPagination);
            const addLink = (number, label, aria) => {
              const link = document.createElement('a');
              const destination = new URL(url);
              destination.searchParams.set('sv_page', number);
              destination.searchParams.delete('page');
              link.href = destination.href;
              link.textContent = label;
              if (aria) link.setAttribute('aria-label', aria);
              link.addEventListener('click', event => {
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                event.preventDefault();
                history.pushState(null, '', destination);
                this.renderStockPage(destination, true);
              });
              nav.append(link);
            };
            if (page > 1) addLink(page-1, '←', this.dataset.stockPrevious);
            let last = 0;
            for (let number=1; number<=pages; number++) {
              if (number!==1 && number!==pages && Math.abs(number-page)>2) continue;
              if (last && number-last>1) {
                const dots=document.createElement('span'); dots.textContent='…'; nav.append(dots);
              }
              if (number===page) {
                const current=document.createElement('span'); current.className='is-current'; current.setAttribute('aria-current','page'); current.textContent=number; nav.append(current);
              } else addLink(number, String(number));
              last=number;
            }
            if (page < pages) addLink(page+1, '→', this.dataset.stockNext);
            results.append(nav);
          }
        }
        results.hidden = false;
        if (focus) { results.focus({preventScroll:true}); results.scrollIntoView({block:'start',behavior:'auto'}); }
      }
      disconnectedCallback() {
        this.cleanup?.();
        this.stockAbort?.abort();
        window.removeEventListener('popstate', this.onStockPop);
        this.bound = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sv-shipping-quote"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sv-shipping-quote')) {
  customElements.define('sv-shipping-quote', class extends HTMLElement {
    connectedCallback() {
      const products = this.querySelector('[data-quote-products]');
      if (!products || products.hasAttribute('data-returned-body') || this.initialized) return;
      this.initialized = true;
      const params = new URLSearchParams(window.location.search);
      const title = (params.get('product') || '').slice(0,500).trim();
      if (!title) return;
      const variant = (params.get('variant') || '').slice(0,300).trim();
      const sku = (params.get('sku') || '').slice(0,150).trim();
      const count = Number(params.get('quantity') || 1);
      const quantity = Number.isSafeInteger(count) && count > 0 && count <= 1000000 ? count : 1;
      products.value = [title, variant && variant !== 'Default Title' ? variant : '', sku ? this.dataset.skuLabel + ' ' + sku : '', this.dataset.quantityLabel + ': ' + quantity].filter(Boolean).join(' / ');
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
